import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useSession } from '../lib/useSession'

/** Gate authenticated product routes (7d+). */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, bootstrapped } = useSession()
  if (!bootstrapped) return null
  if (!isAuthenticated) return <Navigate to="/passkey" replace />
  return <>{children}</>
}
